// removed by extract-text-webpack-plugin
module.exports = {"card-container":"theme--card-container--19xddy9P","cardContainer":"theme--card-container--19xddy9P","card":"theme--card--17QYesIj"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/sign/baseComponents/Card/theme.scss
// module id = 227
// module chunks = 0